module.exports = __webpack_public_path__ + "img/periodic_overstay_on.f2d2cf69.png";